import styled from '@emotion/styled';
import { breakpoints, radius, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';
import { TextList } from '@naf/text-list';

export const ImageWrapper = styled.div`
  position: relative;
  margin: ${spacing.space80} auto 0;
  padding: 0;
  width: 100%;

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space24};
  }
`;

export const ImageFigure = styled.figure`
  margin: 0;
  position: relative;
  overflow: hidden;
  border-top-left-radius: ${radius.l};
  border-top-right-radius: ${radius.l};

  img {
    width: 100%;
    max-height: 512px;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
`;

export const PartnerlogoWrapper = styled.div`
  position: absolute;
  top: -12px;
  left: 16px;
  background-color: ${nafColor.signature.white};
  border-radius: ${radius.s};
  padding: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow:
    0px 0.76px 1.51px 0px #162f090d,
    0px 3.03px 3.03px 0px #162f090a,
    0px 6.81px 3.78px 0px #162f0908,
    0px 11.35px 4.54px 0px #162f0903,
    0px 18.15px 5.3px 0px #162f0900;

  img {
    height: 32px;

    @media (max-width: ${breakpoints.m}) {
      height: 24px;
    }
  }

  @media (min-width: ${breakpoints.m}) {
    left: ${spacing.space64};
  }
`;

export const StyledHeaderText = styled(Text)`
  margin: 0;
`;

export const StyledTextList = styled(TextList)`
  margin-bottom: ${spacing.space32} !important;
`;
